import { render } from "./ConfigureKiosk.vue?vue&type=template&id=23955d0d"
import script from "./ConfigureKiosk.vue?vue&type=script&lang=js"
export * from "./ConfigureKiosk.vue?vue&type=script&lang=js"

import "./ConfigureKiosk.vue?vue&type=style&index=0&id=23955d0d&lang=scss"
script.render = render

export default script